import { render, staticRenderFns } from "./CartIcon2.vue?vue&type=template&id=a184ccca"
import script from "./CartIcon2.vue?vue&type=script&lang=js"
export * from "./CartIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports